module.exports = "var agentZipCode = '';\nvar isValidAgentZip = function isValidAgentZip() {\n  return /(\\d{5})/.test(agentZipCode);\n};"